export const OTHER_USER = '100_OtherUser';
export const CHOOSE_USER = '100_ChooseUser';
export const USER = '100_User';
export const OK = '100_Ok';
export const EXTRA_TAB_NOT_ALLOWED = '100_ExtraTabNotAllowed';
export const MODAL_RESET_CASHREGISTER = '100_ModalResetCashRegister'
export const RESET = '100_Reset'
export const MODAL_CANCEL_RECEIPT = '100_ModalCancelReceipt'
export const CANCEL_RECEIPT_NOT_ALLOWED = '100_CancelReceiptNotAllowed'
export const MODAL_DELETE_TICKET = '100_ModalDeleteTicket'
export const MODAL_SAVE_TICKET = '100_ModalSaveTicket'
export const LABEL_YES = '100_LabelYes'
export const LABEL_NO = '100_LabelNo'
export const STATUS = '100_Status'
export const FUNCTIONS = '100_Functions'
export const CHANGE = '100_Change'
export const STOP_RECEIPT = '100_StopReceipt'
export const Z_REPORT = '100_ZReport'
export const X_REPORT = '100_XReport'
export const Z_REPORT_GENERATED = '100_ZReportGenerated'
export const X_REPORT_GENERATED = '100_XReportGenerated'
export const X_REPORT_NOT_AVAILABLE = '100_XReportNotAvailable'
export const PRINT_OBJECTREPORT = '100_PrintObjectReport'
export const OBJECT_REPORT_GENERATED = '100_ObjectReportGenerated'
export const ERROR_LICENSE = '100_ErrorLicense'
export const EXPIRE_LICENSE1 = '100_ExpireLicense1'
export const EXPIRE_LICENSE2 = '100_ExpireLicense2'
export const PRINT_TEST = '100_PrintTest'
export const STATUS_OK = '100_StatusOk'
export const CANCEL = '100_Cancel'
export const DELETE = '100_Delete'
export const DELETE_ALL = '100_DeleteAll'
export const CLOSE = '100_Close'
export const PRINT_HISTORY = '100_PrintHistory'
export const BACK = '100_Back'
export const NEXT = '100_Next'
export const LOGIN = '100_Login'
export const PASSWORD = '100_Password'
export const RETOUR = '100_Retour'
export const SELECT_POS_ENVIRONMENT = '100_SelectPosEnvironment'
export const SELECT_POS = '100_SelectPos'
export const LICENSE = '100_License'
export const RECEIPT_IS_OPEN = '100_ReceiptIsOpen'
export const SUB_TOTAL = '100_SubTotal'
export const CLOSE_POS = '100_ClosePos'
export const MODAL_CLOSE_CASHREGISTER = '100_ModalCloseCashRegister'
export const MODAL_NO_BLACKBOX_CONNECTION = '100_ModalNoBlackboxConnection'
export const LOADING = '100_Loading'
export const CHOOSE_ENVIRONMENT = '100_ChooseEnvironment'
export const FETCH_CASHREGISTER_ENVIRONMENT = '100_FetchCashregisterEnvironment'
export const FETCH_USERS = '100_FetchUsers'
export const FETCH_LICENSES = '100_FetchLicenses'
export const PREPARE_CASHREGISTER = '100_PrepareCashregister'
export const ERROR_FETCHING_DATA = '100_ErrorFetchingData'
export const RETOUR_NOT_POSSIBLE = '100_RetourNotPossible'
export const OBJECT_NOT_FOUND = '100_ObjectNotFound'
export const ENTER_OBJECT_NUMBER = '100_EnterObjectNummer'
export const RECEIPT_ALREADY_OPEN = '100_ReceiptAlreadyOpen'
export const ERROR_WHILE_PRINTING = '100_ErrorWhilePrinting'
export const NO_VALID_RECEIPTLINE_SELECTED = '100_NoValidReceiptLineSelected'
export const SELECT_OBJECT = '100_SelectObject'
export const NO_ARTICLES_ENTERED = '100_NoArticlesEntered'
export const NO_AMOUNT_TO_PAY = '100_NoAmountToPay'
export const NO_RECEIPT_OPEN = '100_NoReceiptOpen'
export const ENTER_VALID_QUANTITY_TO_DIVIDE_RECEIPTAMOUNT = '100_EnterValidQuantityToDivideReceiptAmount'
export const SPLIT = '100_Split'
export const CHOOSE_OBJECT_TO_SPLIT = '100_ChoseObjectToSplit'
export const OPEN_OBJECT = '100_OpenObject'
export const CHOOSE_OBJECT = '100_ChooseObject'
export const CHOOSE_PRINTER = '100_ChoosePrinter'
export const CHECKOUT = '100_Checkout'
export const FETCH_DEVICES = '100_FetchDevices'
export const FETCH_PAYMENT_METHODS = '100_FetchPaymentMethods'
export const FETCH_CONFIGURATIONS = '100_FetchConfigurations'
export const CONFIGURATIONS = '100_Configurations'
export const SELECT_START_AND_END_DATE = '100_SelectStartAndEndDate'
export const INVALID_DATE_SELECTED = '100_InvalidDateSelected'
export const FETCH_ARTICLES = '100_FetchArticles'
export const FETCH_OBJECTS = '100_FetchObjects'
export const NOTE_PRINTED = '100_NotePrinted'
export const ERROR_PRINTING_NOTE = '100_ErrorPrintingNote'
export const ADD_NOT_POSSIBLE = '100_AddNotPossible'
export const NO_RECEIPTNUMBER = '100_NoReceiptNumber'
export const NO_PAYMENTMETHODS = '100_NoPaymentMethods'
export const PAYMENTMETHOD_FOR_INVOICE = '100_PaymentMethodForInvoice'
export const ONLY_ONE_PAYMENTMETHOD = '100_OnlyOnePaymentMethod'
export const OBJECT_OPEN_BY_CASHREGISTER = '100_ObjectOpenByCashregister'
export const PARTIAL_PAYMENT_AMOUNT = '100_PartialPaymentAmount'
export const MESSAGE_PRINTING_FAILED = '100_MessagePrintingFailed'
export const SELECT_PAYMENT_METHOD = '100_SelectPaymentMethod'
export const NO_PAYMENT_METHOD_SELECTED = '100_NoPaymentMethodSelected'
export const PAYMENT_METHOD_NOT_ALLOWED = '100_PaymentMethodNotAllowed'
export const DEVICE_ID = '100_DeviceId'
export const SERIALNUMBER = '100_SerialNumber'
export const NO_WORKING_PRINTER = '100_NoWorkingPrinter'
export const TABLE_IN_USE = '100_TableInUse'
export const DISCOUNT_NOT_POSSIBLE = '100_DiscountNotPossible'
export const NO_QUANTITY = '100_NoQuantity'
export const DISCOUNT_ALREADY_EXISTS = '100_DiscountAlreadyExists'
export const PERCENTAGE_TO_HIGH = '100_PercentageToHigh'
export const AMOUNT = '100_Amount'
export const AMOUNT_TO_HIGH = '100_AmountToHigh'
export const WORK_IN = '100_WorkIn'
export const WORK_OUT = '100_WorkOut'
export const PRINT_MISSING_RECEIPT = '100_PrintMissingReceipt'
export const MISSING_ARTICLE_PRICE = '100_MissingArticlePrice'
export const EMPTY_PRICE_NOT_ALLOWED = '100_EmptyPriceNotAllowed'
export const FETCH_RIGHTS = '100_FetchRights'
export const NO_RIGHTS = '100_NoRights'
export const OPEN_OBJECT_REQUIRED = '100_OpenObjectRequired'
export const FETCH_PRICELISTS = '100_FetchPriceLists'
export const NONE = '100_None'
export const SELECT_PRICELIST = '100_SelectPriceList'
export const X_REPORT_ALL = '100_XReportAll'
export const EDIT = '100_Edit'
export const CONFIRM = '100_Confirm'
export const CONTINUE = '100_Continue'
export const NO_VALID_EMAIL = '100_NoValidEmail'
export const EMAIL = '100_Email'
export const BADGE = '100_Badge'
export const CUSTOMERGROUP = '100_CustomerGroup'
export const OBJECT_NAME = '100_ObjectName'
export const NAME = '100_Name'
export const GENDER = '100_Gender'
export const DATE_OF_BIRTH = '100_DateOfBirth'
export const CUSTOMER_GROUP_DATE_TO = '100_CustomerGroupDateTo'
export const STREET = '100_Street'
export const HOUSE_NUMBER = '100_HouseNumber'
export const ZIPCODE = '100_ZipCode'
export const IDENTIFICATION_NUMBER = '100_IdentificationNumber'
export const CUSTOMER_NUMBER = '100_CustomerNumber'
export const CITY = '100_City'
export const COUNTRY = '100_Country'
export const TELEPHONE_NUMBER = '100_TelephoneNumber'
export const CHOOSE_OBJECT_FOR_MERGE = '100_ChooseObjectForMerge'
export const NO_VALID_LINES = '100_NoValidLines'
export const KIOSK_CONFIRM_ORDER = '100_KioskConfirmOrder'
export const NO_OBJECTS_AVAILABLE = '100_NoObjectsAvailable'
export const ORDER_BEING_PREPARED = "100_OrderBeingPrepared"
export const ORDER_OVERVIEW = '100_OrderOverview'
export const LABEL_RECEIPT_ORDERNUMBER = "100_LabelReceiptOrderNumber"
export const QUANTITY = "100_Quantity"
export const DESCRIPTION = "100_Description"
export const PRICE = "100_Price"
export const BUTTON_NEW_ORDER = "100_ButtonNewOrder"
export const ERROR_INCORRECT_PASSWORD = "100_ErrorIncorrectPassword"
export const ERROR_INCORRECT_IDENTIFICATIONNUMBER = "100_ErrorIncorrectIdentificationNumber"
export const ERROR_INCORRECT_VATNUMBER = "100_ErrorIncorrectVatNumber"
export const ERROR_INCORRECT_GLNNUMBER = "100_ErrorIncorrectGlnNumber"
export const MANAGER_ENABLED = "100_ManagerEnabled"
export const MANAGER_DISABLED = "100_ManagerDisabled"
export const CUSTOMER = "100_Customer"
export const PICKUPDATE = "100_PickupDate"
export const EMPLOYEE = "100_AltEmployee"
export const PAY_ORDER = "100_PayOrder"
export const CLOSE_ORDER = "100_CloseOrder"
export const ORDER_DATE = "100_OrderDate"
export const ORDER_NUMBER = "100_OrderNumber"
export const PAGERNUMBER = "100_PagerNumber"
export const SELECT_PAGER = "100_SelectPager"
export const INVALID_PAGER_MESSAGE = "100_InvalidPagerMessage"
export const PAGER = "100_Pager"
export const ARTICLE = "100_Article"
export const RECEIPT_UNLOCKED = '100_ReceiptUnlocked'
export const LABEL_RECEIPTNUMBER = '100_ReceiptNumber'
export const CLOSE_OBJECT = '100_CloseObject'
export const PROCESS_OBJECT = '100_ProcessObject'
export const ERROR_OPEN_OBJECT_PRODUCTION = '100_ErrorOpenObjectProduction'
export const MESSAGE_PROCESS_OBJECTITEM = '100_MessageProcessObjectitem'
export const NEGATIVE_SALDO_MESSAGE = '100_NegativeSaldoMessage'
export const FETCH_DEFAULT_CHANGE = '100_FetchDefaultChange'
export const ROUNDING = '100_Rounding'
export const BARCODE = '100_Barcode'
export const MALE = '100_Male'
export const FEMALE = '100_Female'
export const SCAN_BARCODE = '100_ScanBarcode'
export const CONFIRM_ALLOW_ACCESS = '100_ConfirmAllowAccess'
export const INVOICE_REFERENCE = '100_InvoiceReference'
export const INVOICE_REFERENCE_INPUT_MESSAGE = '100_InvoiceReferenceInputMessage'
export const BARCODE_INPUT_MESSAGE = '100_BarcodeInputMessage'
export const INPUT_EMPTY_MESSAGE = '100_InputEmptyMessage'
export const BARCODE_IN_USE_MESSAGE = '100_BarcodeInUseMessage'
export const FETCH_TICKETS = '100_FetchTickets'
export const TICKET_REFERENCE = '100_TicketReference'
export const TICKET_LIST = '100_TicketList'
export const TICKET = '100_Ticket'
export const SELECT_TICKETS_AND_QUANTITY = "100_SelectTicketsAndQuantity"
export const SELECT_CUSTOMER_OR_REFERENCE = "100_SelectCustomerOrReference"
export const DISCOUNT = '100_Discount'
export const SURCHAGE = '100_Surchage'
export const PRINT_INVOICE = "100_PrintInvoiceQuestion"
export const PRINT_INVOICE_QUESTION = "100_PrintInvoice"
export const VAT_NUMBER = "100_VatNumber"
export const GLN_NUMBER = "100_GlnNumber"
export const ALLOW_AFTER_PAY = '100_AllowAfterPay'
export const SHOULD_INVOICE = '100_ShouldInvoice'
export const EINVOICE_ACTIVE = '100_EInvoiceActive'
export const CUSTOMER_NOT_FOUND = "100_CustomerNotFound"
export const NO_INVOICE = "100_NoInvoice"
export const EMAIL_AND_PRINT = "100_EmailAndPrint"
export const SEND_MAIL = "100_SendMail"
export const PRINT = "100_Print"
export const NO_CUSTOMER_LINKED_TO_RECEIPT_MESSAGE = "100_NoCustomerLinkedToReceiptMessage"
export const NO_CUSTOMER = "100_NoCustomer"
export const NO_INVOICE_MESSAGE = "100_NoInvoiceMessage"
export const INVALID_VAT_MESSAGE = "100_InvalidVATMessage"
export const INVOICE_ACTION_ERROR = "100_InvoiceActionError"
export const NO_RESERVATION_FOUND = '100_NoReservationFound'
export const RESERVATION = '100_Reservation'
export const SCAN_RESERVATION = '100_ScanReservation'
export const SCAN_TICKET = '100_ScanTicket'
export const SEARCH_TICKET = '100_SearchTicket'
export const COLLECT_RESERVATION = '100_CollectReservation'
export const NO_TICKETS_FOUND = '100_NoTicketsFound'
export const RESERVATION_COLLECTED = '100_ReservationCollected'
export const CASH_IN = '100_CashIn'
export const CASH_OUT = '100_CashOut'
export const CASH_IN_TITLE = '100_CashInTitle'
export const CASH_OUT_TITLE = '100_CashOutTitle'
export const ADD_AMOUNT_TO_TICKET_BALANCE = '100_AddAmountToTicketBalance'
export const CURRENT_BALANCE = '100_CurrentBalance'
export const BALANCE = '100_Balance'
export const PAY = '100_Pay'
export const INVOICE_LATER = '100_InvoiceLater'
export const TO_INVOICE = '100_ToInvoice'
export const SELECTION = '100_Selection'
export const EVERYTHING = '100_Everything'
export const SET_MAIL_QUESTION = '100_SetMailQuestion'
export const INVOICE_EMPTY_RECEIPT_MESSAGE = '100_InvoiceEmptyReceiptMessage'
export const NO_FREE_OBJECT = '100_NoFreeObject'
export const ARTICLES_NOT_FOUND = '100_ArticlesNotFound'
export const ARTICLE_INFO_NOT_FOUND = '100_ArticleInfoNotFound'
export const ERROR_MESSAGE_CREATING_DEFAULT_TICKET = '100_ErrorMessageCreatingDefaultTicket'
export const TICKET_OBJECT_UNKNOWN = '100_TicketObjectUnknown'
export const ERROR_MESSAGE_LINK_TICKET_TO_OBJECT = '100_ErrorMessageLinkTicketToObject'
export const PRINTER_NOT_AVAILABLE = '100_PrinterNotAvailable'
export const OBJECT_ITEM_NUMBER = '100_ObjectItemNumber'
export const UNKNOWN = '100_Unknown'
export const NEW_CUSTOMER = '100_NewCustomer'
export const NEW = '100_New'
export const SEARCH_TERM = '100_SearchTerm'
export const EXISTING_CUSTOMER = '100_EditCustomer'
export const SAVE = '100_Save'
export const READPASSPORT = '100_ReadPassport'
export const AGE = '100_Age'
export const OVERRULE_AGE = '100_OverruleAge'
export const ARTICLE_HAS_AGE_CONTROL = '100_ArticleHasAgeControl'
export const ARTICLE_MINIMUM_AGE_ALERT = '100_ArticleMinimumAgeAlert'
export const ARTICLE_MAXIMUM_AGE_ALERT = '100_ArticleMaximumAgeAlert'
export const RECEIPT_ONE_OR_MORE_AGE_CONTROL = '100_ReceiptOneOrMoreAgeControl'
export const CUSTOMER_NO_DATE_OF_BIRTH = '100_CustomerNoDateOfBirth'
export const CUSTOMER_INVALID_AGE = '100_CustomerInvalidAge'
export const IMPORT_ID_DATA_WARNING_EXISTING_CUSTOMERS = '100_ImportIdDataWarningExcistingCustomers'
export const TAKE_OVER = '100_TakeOver'
export const EXISTING_CUSTOMERS_FOUND = '100_ExcistingCustomersFound'
export const INPUT_START_DATE = '100_EnterStartDate'
export const INPUT_END_DATE = '100_EnterEndDate'
export const INPUT_INVALID_DATE = '100_InvalidDateEntered'
export const EMPTY_RECEIPT = '100_EmptyReceipt'
export const NO_RECEIPT = '100_NoReceipt'
export const STOCKMESSAGE_MINSTOCK = '100_StockMessageMinStock'
export const ARTICLE_NOT_AVAILABLE = '100_ArticleNotAvailable'
export const NO_PAYMENTMETHOD_FOR_INVOICE = '100_NoPaymentMethodForInvoice'
export const NO_OVERPAYMENT_ALLOWED = '100_NoOverpaymentAllowed'
export const OPENORDERCOLUMN_PRICELIST = '100_PriceList'
export const OPENORDERCOLUMN_OBJECT = '100_Object'
export const OPENORDERCOLUMN_RECEIPT = '100_Receipt'
export const OPENORDERCOLUMN_CUSTOMER = '100_Customer'
export const OPENORDERCOLUMN_SYSTEMUSER = '100_User'
export const OPENORDERCOLUMN_TIME = '100_Time'
export const OPENORDERCOLUMN_QUANTITY = '100_Quantity'
export const OPENORDERCOLUMN_ARTICLE = '100_Article'
export const OPENORDERCOLUMN_CONFIGURATION = '100_Configuration'
export const ADD_CONFIGURATION_PER_ARTICLE = '100_AddConfigurationPerArticle'
export const CUSTOMER_LIST = '100_CustomerList'
export const ARTICLE_LIST = '100_ArticleList'
export const VALID_FROM = '100_ValidFrom'
export const VALID_TILL = '100_ValidTill'
export const TICKET_USAGE = '100_TicketUsage'
export const ADDRESS = '100_Address'
export const ENTRANCE_AND_EXITS = '100_EntranceAndExits'
export const DATE_AND_TIME = '100_DateAndTime'
export const ENTRANCE_GATE = '100_EntranceGate'
export const EXPIRES_ON = '100_ExpiresOn'
export const RESET_FISCALPRINTER = '100_ResetFiscalPrinter'
export const TECHNICAL_ERROR = '100_TechnicalError'
export const PAYMENT_FAILED = '100_PaymentFailed'
export const CREDIT = '100_Credit'
export const CREDIT_MIXED_NOT_ALLOWED = '100_CreditMixedNotAllowed'
export const CREDIT_ONLY_ONE_ALLOWED = '100_CreditOnlyOneAllowed'
export const ORIGINAL_INVOICE_NUMBER = '100_OriginalInvoiceNumber'
export const ENTER_ORIGINAL_INVOICE_NUMBER = '100_EnterOriginalInvoiceNumber'
export const NOT_VALID_INVOICENUMBER = '100_NotValidInvoiceNumber'
export const INVOICE_CUSTOMER = '100_InvoiceCustomer'
export const STORE = '100_Store'
export const COMPANY = '100_Company'
export const RECEIPT = '100_Receipt'
export const DATE = '100_Date'
export const NO_AVAILABLE_INVOICES = '100_NoAvailableInvoices'


// WEBPACK FOOTER //
// src/constants/Resources.js